<mat-card class="card-container">
    <div class="text-content">{{libelle}}</div>

    <div class="button-row">
      <button mat-raised-button color="primary" (click)="closeDialog()">Annuler</button>
      <button mat-raised-button color="primary" (click)="validateDialog()">Valider</button>
    </div>
  </mat-card>
  